// extracted by mini-css-extract-plugin
export default {"colorPicker":"lJmVCaUJkRBAZROcdATw"};